<template>
  <header>
    <div class="header-container">
      <button
        class="btn-reset close__card flex"
        @click="this.$emit('update:modelValue', val)"
      >
        <svg
          width="10"
          height="16"
          viewBox="0 0 10 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2.28571L3.75 8L10 13.7143L8.75 16L0 8L8.75 0L10 2.28571Z"
            fill="#9299AA"
          />
        </svg>
      </button>
      <nav class="menu">
        <a class="menu-triger" href="#"></a>
        <div class="menu-popup">
          <a class="menu-close" href="#"></a>
          <ul class="nav__list">
            <li class="nav__item">
              <a class="navbar__link list-reset" href="#apartments">Квартира</a>
            </li>
            <li class="nav__item">
              <a class="navbar__link list-reset" href="#object">Объект</a>
            </li>
            <li class="nav__item">
              <a class="navbar__link list-reset" href="#contacts">Контакты</a>
            </li>
          </ul>
        </div>
      </nav>
      <div class="logo">
        <img
          src="https://spa-bitrix.ru/masthev_selections/img/logo.png"
          alt=""
        />
      </div>
    </div>
  </header>
  <main>
    <section class="banner" :style="`background-image: url('${item.img.url}')`">
      <div class="banner__details">
        <div class="banner__text">
          <div class="banner__title">
            <h1>{{ item.title }}</h1>
          </div>
        </div>
      </div>
    </section>
    <section id="apartments" class="apartments">
      <div class="title__section">
        <h2 class="title">Квартира</h2>
        <div class="title__section-line"></div>
      </div>
      <div class="apartments__information">
        <div class="apartments__information-plan">
          <img :src="item.images[1].url" class="plan" alt="План апартаментов" />
        </div>
        <div class="apartments__details">
          <div class="apartments__details-title">
            <h3>{{ item.address }}</h3>
          </div>
          <div class="apartments__icon-list">
            <div class="apartments__icon-item">
              <img
                src="https://spa-bitrix.ru/masthev_selections/img/ico_area.png"
                class="apartments__icon"
                alt=""
              />
              <span class="apartments__icon-description"
                >Общая площадь: <strong>{{ item.square }}</strong></span
              >
            </div>
            <div class="apartments__icon-item">
              <img
                src="https://spa-bitrix.ru/masthev_selections/img/ico_floor.png"
                class="apartments__icon"
                alt=""
              />
              <span class="apartments__icon-description"
                >Этажность: <strong>{{ item.floor }}</strong></span
              >
            </div>
            <div class="apartments__icon-item">
              <img
                src="https://spa-bitrix.ru/masthev_selections/img/ico_bedroom.png"
                class="apartments__icon"
                alt=""
              />
              <span class="apartments__icon-description"
                >Количество спален: <strong>{{ item.rooms }}</strong></span
              >
            </div>
            <div class="apartments__icon-item">
              <img
                src="https://spa-bitrix.ru/masthev_selections/img/otd.png"
                class="apartments__icon"
                alt=""
              />
              <span class="apartments__icon-description"
                >Тип отделки: <strong>{{ item.otc }}</strong></span
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="object" class="object">
      <div class="title__section">
        <h2 class="title">Объект</h2>
        <div class="title__section-line"></div>
      </div>
      <div class="object__gallery">
        <v-carousel
          show-arrows="hover"
          cycle
          cover
          draggable
          transition
          hide-delimiter-background
        >
          <v-carousel-item
            class="object__gallery-item"
            v-for="(slide, i) in item.images.filter(
              (e, index) => index !== 0 || index !== 1
            )"
            :key="i"
            :src="slide.url"
          >
          </v-carousel-item>
        </v-carousel>
      </div>
      <div class="object__information">
        <div class="object__information-line"></div>
        <div class="object__information-description">
          <p>
            {{ item.details }}
          </p>
        </div>
        <div class="object__information-line"></div>
      </div>
    </section>
      <section class="object__map">
      <yandex-map
        v-if="modelValue == true"
        :key="item.id"
        cursor-grab
        :settings="{
          location: {
            center: item.coordinates,
            zoom: 15,
          },
        }"
        width="90%"
        height="55vh"
      >
        <yandex-map-default-scheme-layer />
        <yandex-map-default-features-layer />
        <yandex-map-controls :settings="{ position: 'top left' }">
        </yandex-map-controls>
        <yandex-map-controls
          :settings="{ position: 'bottom left', orientation: 'vertical' }"
        >
        </yandex-map-controls>
        <yandex-map-controls :settings="{ position: 'right' }">
          <yandex-map-zoom-control />
        </yandex-map-controls>
        <YandexMapMarker
          :marker-id="item.id"
          :settings="{
            position: 'top left-center',
            coordinates: item.coordinates,
            properties: { item },
          }"
        >
          <div class="marker__container">
            <div class="clip">{{ item.currency.id + item.mapPrice }} млн</div>
            <div class="marker" />
          </div>
        </YandexMapMarker>
      </yandex-map>
    </section>
    <section id="contacts" class="contacts">
      <div class="title__section">
        <h2 class="title">Контакты</h2>
        <div class="title__section-line"></div>
      </div>
      <div class="contact__information">
        <div class="contact__details">
          <div class="contacts__title">
            <span>Контакты</span>
          </div>
          <div class="contacts__phone">
            <span class="contacts__sub-name">{{ item.responsible }}</span>
            <div class="contacts__phone-details">
              <div class="icon__phone">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.40894 3.94106C7.73727 3.44593 7.28496 3.33414 7.04226 3.38151C6.04101 3.57691 5.44749 3.96667 4.64337 4.77079C3.54575 5.86839 3.01318 6.68796 3.24513 7.93058C3.51219 9.36125 4.81689 11.5448 8.41291 15.1408C12.0087 18.7366 14.2054 20.055 15.6441 20.3277C16.3108 20.4541 16.8185 20.3553 17.2741 20.1309C17.7612 19.891 18.2302 19.4872 18.7681 18.9257C19.2452 18.4279 19.5347 18.0804 19.7373 17.7385C19.9303 17.4128 20.0671 17.0527 20.1728 16.5118C20.2202 16.2691 20.1084 15.8168 19.6132 15.145C19.1513 14.5185 18.4997 13.8963 17.8973 13.3883C17.4998 13.0532 16.8848 13.0318 16.388 13.4037L14.8697 14.5403C13.5001 15.5656 11.5864 15.4187 10.3781 14.2104L9.34333 13.1757C8.13502 11.9674 7.98816 10.0536 9.0134 8.68408L10.15 7.1658C10.5219 6.66899 10.5005 6.05399 10.1653 5.65648C9.65746 5.05422 9.03533 4.4028 8.40894 3.94106ZM9.59567 2.33119C10.4051 2.92787 11.1441 3.71475 11.6943 4.36717C12.6971 5.55639 12.6153 7.20989 11.7511 8.36437L10.6145 9.88265C10.191 10.4483 10.2458 11.2497 10.7575 11.7614L11.7923 12.7962C12.3041 13.308 13.1054 13.3627 13.6711 12.9393L15.1894 11.8026C16.3439 10.9384 17.9973 10.8566 19.1865 11.8593C19.8391 12.4095 20.6262 13.1486 21.223 13.9582C21.7864 14.7224 22.3533 15.7809 22.1357 16.8952C21.9959 17.6108 21.7906 18.1964 21.4579 18.758C21.1348 19.3034 20.715 19.7847 20.2122 20.3094C19.6296 20.9175 18.9653 21.5274 18.1578 21.9251C17.3189 22.3383 16.3708 22.501 15.2716 22.2927C13.1786 21.896 10.6038 20.1601 6.99869 16.555C3.39388 12.9502 1.66901 10.3864 1.27909 8.29757C0.854079 6.02068 2.03716 4.54855 3.22916 3.35656C4.21375 2.37199 5.14736 1.71358 6.65918 1.41854C7.7733 1.20111 8.83152 1.76789 9.59567 2.33119Z"
                    fill="#263C44"
                  />
                </svg>
              </div>
              <a href="tel:+79255024106">+7 (925) 502-41-06</a>
            </div>
          </div>
          <div class="contacts__time">
            <div class="icon__time">
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.6335 12.0001C22.6335 10.6869 22.3749 9.38654 21.8723 8.17329C21.3698 6.96003 20.6332 5.85764 19.7046 4.92905C17.8292 3.05369 15.2857 2.00012 12.6335 2.00012C9.98138 2.00012 7.43784 3.05369 5.56248 4.92905C4.63389 5.85764 3.8973 6.96003 3.39475 8.17329C2.8922 9.38654 2.63355 10.6869 2.63355 12.0001C2.63355 14.6523 3.68711 17.1958 5.56248 19.0712C7.43784 20.9466 9.98138 22.0001 12.6335 22.0001C13.9468 22.0001 15.2471 21.7415 16.4604 21.2389C17.6736 20.7364 18.776 19.9998 19.7046 19.0712C20.6332 18.1426 21.3698 17.0402 21.8723 15.827C22.3749 14.6137 22.6335 13.3133 22.6335 12.0001ZM8.43355 16.2001L11.6335 11.0001L17.6335 11.0001L17.6335 12.5001L12.4335 12.5001L9.73355 17.0001L8.43355 16.2001Z"
                  fill="#263C44"
                />
              </svg>
            </div>
            <span class="contacts__sub-name">
              Время работы: с 10:00 до 19:00
            </span>
          </div>
        </div>
        <div class="contact__form">
          <!-- form-bx -->
        </div>
      </div>
    </section>
  </main>
  <footer>
    <div class="footer-section">
      <div class="footer-section__copyright">
        <span>© 2024 MUST HAVE BURO.</span>
      </div>
    </div>
  </footer>
</template>
<script>
import {
  YandexMap,
  YandexMapDefaultSchemeLayer,
  YandexMapDefaultFeaturesLayer,
  YandexMapZoomControl,
  YandexMapControls,
  YandexMapMarker,
} from "vue-yandex-maps";

export default {
  name: "selection-vue",
   components: {
    YandexMap,
    YandexMapDefaultSchemeLayer,
    YandexMapDefaultFeaturesLayer,
    YandexMapZoomControl,
    YandexMapControls,
    YandexMapMarker,
  },
  props: {
    url: String,
    item: Object,
    modelValue: Boolean,
  },
  mounted() {
    const images = this.item.images.filter(function (element, index) {
      return index !== 0 || index !== 1;
    });
    console.log({ images });
    console.log(this.item);
  },
};
</script>
<style scoped>
.object__map {
  display: flex;
  justify-content: center;
}
.clip {
  z-index: 10 !important;
  cursor: pointer;
  bottom: 22px;
  right: -36px;
  padding: 2px;
  position: fixed !important;
  background-color: #b71234;
  border-radius: 13px;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  text-align: center;
  min-width: 90px;
}

.clip::after {
  content: url("data:image/svg+xml;charset=UTF-8,%3csvg width='60' height='12' viewBox='0 0 60 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M59.3047 0H0.74414C1.58674 0.199128 2.46227 0.314337 3.36157 0.336229L17.7819 0.687281C23.6216 0.829443 28.6091 4.94152 29.8619 10.647C29.9967 11.2607 30.8624 11.2863 31.0331 10.6816L31.0768 10.5267C32.688 4.81974 37.8274 0.826804 43.7555 0.676281L56.6451 0.348997C57.5595 0.32578 58.4493 0.206156 59.3047 0Z' fill='%23b71234'/%3e%3c/svg%3e ");
  position: fixed;
  bottom: 3px;
  right: 25px;
  display: grid;
  justify-items: center;
  width: 100%;
}

.clip span {
  color: white;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 23px;
  padding: 0 10px;
  width: 100%;
}
.cluster__marker {
  z-index: -1 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 40px;
  border: 2px white solid;
  width: 25px;
  height: 25px;
  color: #fff;
  background-color: #b71234;
}
.marker {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 40px;
  border: 2px white solid;
  width: 12px;
  height: 12px;
  background-color: #b71234;
}

.marker span {
  font-size: 10px;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  width: 21px;
  height: 21px;
  display: grid;
  justify-items: center;
  align-items: center;
}

img {
  max-width: 100%;
}

.list-reset {
  margin: 0;
  padding: 0;
  list-style: none;
}

header {
  background-color: #ffffff;
  position: fixed;
  width: 100%;
}
.header-container {
  width: 70%;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  padding: 1.78571rem 0;
}

.nav__list {
  display: flex;
  gap: 40px;
}

.navbar__link {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 0.92857rem !important;
  text-transform: uppercase;
  color: black;
  transition: 0.3s;
  letter-spacing: 3px;
}

.navbar__link:hover {
  color: #841226;
  transition: 0.3s;
}

.banner {
  background-color: rgba(0, 0, 0, 0.5);
  background-repeat: no-repeat;
  background-blend-mode: color;
  height: 100vh;
  display: grid;
  justify-items: center;
  align-items: center;
  background-size: cover;
  background-position: center center;
}

.banner__details {
  display: grid;
  gap: 35px;
  justify-items: center;
  width: 50%;
}

.banner__text {
  display: grid;
  gap: 20px;
  justify-items: center;
}

.banner__title h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-style: normal;
  text-transform: uppercase;
  color: #ffffff;
  font-size: 2rem;
  text-align: center;
}

.banner__description p {
  color: rgba(255, 255, 255, 0.7);
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.21429rem;
  text-align: center;
}

.title__section {
  display: grid;
  gap: 20px;
  justify-items: center;
  padding: 9.28571rem 0;
}

.title {
  color: #263c44;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-style: normal;
  line-height: 1.4;
  font-size: 2.14286rem;
  letter-spacing: 0.71429rem;
  text-transform: uppercase;
}

.title__section-line {
  height: 1px;
  width: 70px;
  background-color: #263c44;
}

.apartments {
  display: grid;
  gap: 30px;
}
.apartments__information {
  display: flex;
  gap: 20px;
  width: 70%;
  margin: 0 auto;
  padding-bottom: 9.28571rem;
}
.apartments__details {
  width: 50%;
  display: grid;
  gap: 30px;
}
.apartments__information-plan {
  width: 50%;
}
.apartments__details-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-style: normal;
  line-height: 1.4;
  color: #111111;
  font-size: 2.14286rem;
}

.apartments__details-description {
  color: #6c7072;
  font-size: 1.21429rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  line-height: 1.6;

  display: grid;
  gap: 15px;
}
.apartments__icon-list {
  display: grid;
  gap: 30px;
}
.apartments__icon-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.apartments__icon-description {
  color: #6c7072;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.21429rem;
}
.apartments__gallery {
  width: 100%;
}
.apartments__gallery-list {
  display: flex;
}
.object__gallery {
  width: 100%;
}
.object__gallery-list {
  display: flex;
}
.object__information {
  width: 70%;
  margin: 0 auto;
  display: grid;
  gap: 30px;
  padding: 60px 0;
  justify-items: center;
}
.object__information-line {
  height: 1px;
  width: 70%;
  background-color: #263c44;
}
.object__information-description {
  color: #6c7072;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.14286rem;
  line-height: 1.6;
}
.contact__information {
  width: 70%;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}
.contacts {
  padding-bottom: 9.28571rem;
}

.contacts__title {
  text-align: left;
  color: #263c44;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 2rem;
  line-height: 1.4;
}
.contacts__phone-details {
  display: flex;
  gap: 20px;
  align-items: center;
}
.contacts__phone {
  display: grid;
  gap: 15px;
}
.contacts__time {
  display: flex;
  gap: 20px;
  align-items: center;
}
.contacts__sub-name {
  text-align: left;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #263c44;
  font-size: 1.14286rem;
}
.contacts__phone-details a {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #263c44;
  font-size: 1.21429rem;
}
.contact__details {
  width: 50%;
  display: grid;
  gap: 30px;
}

footer {
  background-color: #263c44;
}
.footer-section {
  width: 70%;
  margin: 0 auto;
  padding: 2.85714rem 0;
}
.footer-section__copyright {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #999;
  line-height: 1.6;
  font-size: 1rem;
  text-align: center;
}
@media (max-width: 760px) {
  .header-container {
    width: 90%;
  }
  body {
    overflow-x: hidden;
  }
  .menu-triger {
    display: grid;
    width: 25px;
    height: 100%;
    background: url("") 0 0 no-repeat;
    position: absolute;
    right: 10px;
    top: 0;
    background-position: center;
  }
  .menu-close {
    display: block;
    width: 28px;
    height: 28px;
    background: url("") 0 0 repeat;
    position: absolute;
    right: 10px;
    top: 30px;
    z-index: 100;
  }
  header {
    position: fixed;
  }
  .menu-popup {
    display: none;
    background: #ffffff;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0;
    box-sizing: border-box;
    padding: 50px 20px;
    z-index: 9999;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }
  .nav__list {
    flex-direction: column;
  }
  .body_pointer * {
    cursor: pointer;
  }
  .logo {
    width: 25%;
  }
  .navbar__link {
    font-size: 0.92857rem;
  }
  .banner__details {
    width: 95%;
  }
  .banner__description p {
    line-height: 1.5;
    font-size: 17px;
  }
  .banner__title h1 {
    font-size: 1.8rem;
  }
  .title__section {
    padding: 3.57143rem 0;
  }
  .title {
    font-size: 1.4111rem;
    line-height: 1.4;
  }
  .apartments__information {
    width: 90%;
    flex-direction: column-reverse;
    align-items: center;
  }
  .apartments__information-plan {
    width: 100%;
  }
  .apartments__details {
    width: 100%;
  }
  .apartments__details-title {
    line-height: 1.4;
    font-size: 28px;
    text-transform: uppercase;
    text-align: center;
  }
  .apartments__details-description {
    text-align: center;
    font-size: 16px;
  }
  .apartments__icon-description {
    font-size: 16px;
  }
  .apartments__icon-list {
    gap: 14px;
  }
  .apartments__information {
    gap: 30px;
    padding-bottom: 30px;
  }
  .apartments__gallery-list {
    flex-direction: column;
    gap: 15px;
    padding: 30px 15px 0 15px;
  }
  .object__gallery-list {
    flex-direction: column;
    gap: 15px;
    padding: 30px 15px 0 15px;
  }
  .object__information {
    width: 90%;
    padding: 60px 0 30px 0;
  }
  .apartments__details-description {
    font-size: 16px;
  }
  .contact__information {
    width: 90%;
    flex-direction: column;
  }
  .contact__details {
    width: 100%;
  }
  .contacts__sub-name {
    font-size: 16px;
  }
  .contacts__phone-details a {
    font-size: 16px;
  }
  .contact__details {
    gap: 20px;
  }
  .contacts__phone {
    gap: 10px;
  }
}
</style>
